import { observer } from "mobx-react-lite";
import appStore from "../../../storage/AppStore";
import Btn from "../../../ui/Btn";
import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import clubStore from "../../../storage/ClubStore";
import PageLayout from '../../PageLayout';
import NumericPagination from '../../NumericPagination';
import CompetitionsList from "../../Games/CompetitionList";
import CompetitionsFilter from "../../Games/CompetitionsFilter";
import { startOfMonth } from "../../../common/utils";

const isSameMonth = (d1, d2) =>
  d1.getFullYear() === d2.getFullYear() &&
  d1.getMonth() === d2.getMonth();

const Competitions = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const now = new Date();
    const currentMonthStart = startOfMonth(now);
  
    let from = clubStore.tournament.competitionsQuery.date_from
      ? startOfMonth(new Date(clubStore.tournament.competitionsQuery.date_from))
      : currentMonthStart;
  
    clubStore.tournament.competitionsQuery.setProperty("date_from", from);
    clubStore.tournament.competitionsQuery.setProperty(
      "date_to",
      isSameMonth(from, now) ? null : endOfMonth(from)
    );
  
    clubStore.tournament.getCompetitions();
  }, []);

  return (
    <PageLayout
      header={
        <div className={"flex justify-content-between align-items-center w-full"}>

          <div className="flex col">
            <h3 className={"m-0"}>{appStore.tr.tournaments}</h3>
          </div>

          <div className="flex col justify-content-end">
            <Btn
              icon="pi pi-plus"
              severity="success"
              onClick={() => navigate('/manager/tournament/new')}
            />
          </div>

        </div>
      }

      filters={<CompetitionsFilter store={clubStore.tournament} />}

      pagination={
        <NumericPagination
          query={clubStore.tournament.competitionsQuery}
          onPageChange={(page) => {
            clubStore.tournament.competitionsQuery.setProperty("page_number", page);
            clubStore.tournament.getCompetitions();
          }}
        />
      }
    >
      <CompetitionsList role={"MGR"} />
    </PageLayout>
  );
};

export default observer(Competitions);